import {createModelSchemaWrapper} from "framework/serializr-integration";
import {primitive} from "serializr";
import {makeAutoObservable} from "mobx";

export class AssetHealthIncidents {
	closed: number
	high: number
	low: number
	medium: number
	open: number
	total: number

	constructor() {
		makeAutoObservable(this)
	}
}

createModelSchemaWrapper(AssetHealthIncidents, {
	closed: primitive(),
	high: primitive(),
	low: primitive(),
	medium: primitive(),
	open: primitive(),
	total: primitive(),
})
